import type {
	ChatMessageReactionRequestModel,
	ChatMessageRequestModel,
	ChatMessageResponseModel,
	HTTPValidationError,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'
import { ContentType } from '@/shared/generated'

export function useSentChatMessageMutation(
	options?: UseMutationOptions<
		ChatMessageResponseModel,
		AxiosError<HTTPValidationError>,
		{
			path: string
			payload: ChatMessageRequestModel
		}
	>
) {
	return useMutation<
		ChatMessageResponseModel,
		AxiosError<HTTPValidationError>,
		{
			path: string
			payload: ChatMessageRequestModel
		}
	>({
		mutationFn: ({ path, payload }) =>
			client.request<ChatMessageResponseModel, HTTPValidationError>({
				path,
				method: 'POST',
				body: payload,
				type: ContentType.Json,
				format: 'json',
			}),
		...(options || {}),
	})
}

export function useSentChatMessageReactionMutation(
	options?: UseMutationOptions<
		void,
		AxiosError<HTTPValidationError>,
		ChatMessageReactionRequestModel
	>
) {
	return useMutation<
		void,
		AxiosError<HTTPValidationError>,
		ChatMessageReactionRequestModel
	>({
		mutationFn: (payload) =>
			client.assistant.assistantChatReactionPost(payload),
		...(options || {}),
	})
}
